import './index.scss';

import { useAuth } from 'admin/Auth';
import { Button, Dropdown, Menu } from 'antd';
import React from 'react';

import { DownIcon } from './icons/down';
import { UserIcon } from './icons/user';

const UserDropdown: React.FC = () => {
  const { user, logout } = useAuth();

  const items = [
    { label: <Button type="link" onClick={logout}>退出登录</Button>, key: 'phone' }
  ];

  const displayName = user.phone?.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') || '';

  return (
    <Dropdown menu={{ items }}>
      <div className="user-dropdown-button d-center">
        <UserIcon />
        <div className="user-dropdown-phone">{displayName}</div>
        <DownIcon />
      </div>
    </Dropdown>
  );
};

export default UserDropdown;
